import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import DownloadIcon from '@mui/icons-material/Download';

import { useAppFile } from '../../../../hooks/use-app-file';
import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

interface IDownloadActionButtonProps
  extends Pick<IBaseActionButtonProps, 'disabled'> {
  link: string;
  fileName: string;
}

const DownloadActionButton = (props: IDownloadActionButtonProps) => {
  const theme = useTheme();
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { downloadFile, isDownloading } = useAppFile(t);
  return (
    <BaseActionButton
      onClick={() => downloadFile(props.link, props.fileName)}
      disabled={props.disabled}
      loading={isDownloading}>
      <DownloadIcon className={classes.icon} />
    </BaseActionButton>
  );
};

export default DownloadActionButton;
